import React from 'react';
import { connect } from 'react-redux';
import { accountOperations } from 'insured-ui-state-mgmt/dist/ducks/account';
import PropTypes from 'prop-types';
import Loading from './Loading';

import NotificationSystem from 'react-notification-system';
import { AddNotification, NotificStyle } from '../assets/constants/notification';
import { Input, Button } from '../assets/constants/styles';
import { validationRegex } from 'insured-ui-state-mgmt/dist/util/Validations';

class RegistrationScreen2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resendEmail: '',
      resendCount: 0,
      totalCount: 0,
      loading: false,
      showEmailForm: false,
      newEmail: '',
    };
    this.notificationSystem = React.createRef();

    this._confirmEmailChange = this._confirmEmailChange.bind(this);
    this._newEmailState = this._newEmailState.bind(this);
    this._showForm = this._showForm.bind(this);
    this._resendEmail = this._resendEmail.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ loading: false });
    // if the user changed the email address and tried to do resend again, verify against the resendemail
    if (nextProps.response.code === 0 && this.state.newEmail !== '' && this.state.newEmail !== this.state.resendEmail) {
      //reset the resend count
      this.setState({ resendEmail: this.state.newEmail, resendCount: 0 });
    }
  }

  componentDidUpdate(prevProps) {
    if (!Object.is(this.props.response, prevProps.response)) {
      if (this.props.response.code === 0) {
        this._addNotification('success', 'Request Success', 'Request completed successfully.');
      } else {
        if (this.props.response.message) {
          this._addNotification('error', 'Api Error', this.props.response.message);
        } else {
          this._addNotification('error', 'Api Error', 'ErrorCode: ' + this.props.response.code);
        }
      }
    }
  }

  componentDidMount() {
    // ToDo: check user loggedin info instead of email in props
    if (!this.props.response.email) {
      console.log('Navigating to screen 1');
      this.props.transition.router.stateService.go('registrationScreen1', {}, { location: true });
    }
    this.setState({
      resendEmail: this.props.response.email,
      resendCount: 0,
      totalCount: this.state.totalCount,
    });
  }

  _resendEmail = () => {
    this.setState({ showEmailForm: false });
    if (this.state.resendCount >= 5) {
      this._addNotification(
        'warning',
        'Input Error',
        'You can only resend verification email 5 times for an email address'
      );
    } else if (this.state.totalCount >= 10) {
      this._addNotification('warning', 'Input Error', 'You can only resend verification email 10 times');
    } else {
      this.setState({
        resendCount: this.state.resendCount + 1,
        totalCount: this.state.totalCount + 1,
      });
      this.setState({ loading: true });
      this.props.resendEmail(this.state.resendEmail);
    }
    /*else {
      if (this.state.totalCount >= 10) {
        this._addNotification(
          'warning',
          'Input Error',
          'You can only resend verification email 10 times'
        );
      } else {
        this.setState({
          resendEmail: this.state.resendEmail,
          resendCount: 1,
          totalCount: this.state.totalCount + 1
        });
        this.setState({ loading: true });
        this.props.resendEmail(this.state.resendEmail);
      }
    }*/
  };

  _showForm = event => {
    event.preventDefault();
    this.setState({ showEmailForm: !this.state.showEmailForm });
  };

  _confirmEmailChange = () => {
    if (
      this.state.newEmail &&
      this.state.newEmail.match(validationRegex.emailRegex) &&
      this.state.newEmail !== this.state.resendEmail
    ) {
      this.setState({ loading: true, showEmailForm: false });
      // ToDo: Pass authToken instead of email
      this.props.changeEmail(this.state.resendEmail, this.state.newEmail);
    } else {
      this._addNotification(
        'warning',
        'Input Error',
        "Invalid Email - should be non-empty and valid email and shouldn't be same as current one."
      );
    }
  };

  _addNotification = (notificLevel, messageTitle, messageBody) => {
    AddNotification(this.notificationSystem.current, notificLevel, messageTitle, messageBody);
  };

  _newEmailState = event => {
    this.setState({ newEmail: event.target.value });
  };

  render() {
    return (
      <div>
        <NotificationSystem ref={this.notificationSystem} style={NotificStyle} />
        {this.state.loading && <Loading show={this.state.loading} />}
        {!this.state.loading && (
          <div style={{ textAlign: 'center' }}>
            <br />
            <div>
              The verification link was sent to <br /> {this.state.resendEmail}
            </div>
            <br />
            <Button className="btn" onClick={this._showForm} style={{ width: '120px', backgroundColor: '#619dbf' }}>
              Change Email
            </Button>
            <br />
            {this.state.showEmailForm && (
              <div className="row">
                <div className="col-md-9 col-sm-8">
                  <Input
                    className="form-control"
                    name="newEmail"
                    onChange={this._newEmailState}
                    placeholder="New Email Address"
                    type="email"
                  />
                </div>
                <div className="col-md-3 col-sm-4">
                  <Button className="btn" onClick={this._confirmEmailChange} style={{ margin: '0' }}>
                    Confirm
                  </Button>
                </div>
              </div>
            )}
            <Button className="btn" onClick={this._resendEmail} style={{ width: '120px', backgroundColor: '#619dbf' }}>
              Resend Email
            </Button>
            <br />
            <div>Click below after you have verified your email</div>
            <br />
            <a data-senna-off="true" href="/c/portal/login">
              <Button className="btn" style={{ width: '250px' }}>
                Continue After Email Verification
              </Button>
            </a>
            <br />
            <br />
            <br />
          </div>
        )}
        {/* </Loading> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  registrationDetails: state.account.registrationDetails,
  response: state.account.response,
});
const mapDispatchToProps = {
  changeEmail: accountOperations.changeEmail,
  resendEmail: accountOperations.resendEmail,
};
RegistrationScreen2.propTypes = {
  changeEmail: PropTypes.func,
  registrationDetails: PropTypes.object,
  resendEmail: PropTypes.func,
  response: PropTypes.object,
  transition: PropTypes.object,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationScreen2);
